import GtmClient from './GtmClient';

export default GtmClient;
